import styled from 'styled-components';
import { Select as MuiSelect } from '@material-ui/core';

export const Select = styled(MuiSelect)`
  & > .MuiSelect-root:focus,
  & > .MuiSelect-root:active {
    background-color: transparent;
    outline: none;
  }
`;